<template>
  <van-loading v-if="payLoading" id="loading" vertical size="40px" text-size="15px">
    支付确认中...
		<div>
			<van-button class="pay-know" slot="button" size="small" @click="$emit('close')">关闭</van-button>
		</div>
	</van-loading>
</template>

<script>
import Button from 'vant/lib/button'
import 'vant/lib/button/style'
import Loading from 'vant/lib/loading'
import 'vant/lib/loading/style'

export default {
  name: 'PayLoading',
  components: {
    [Button.name]: Button,
    [Loading.name]: Loading
  },
  props: {
    payLoading: {
      type: Boolean,
      required: true,
      default: () => false
    }
  }
}
</script>

<style lang="scss" scoped>
  #loading {
    position: fixed;
    display: flex;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    justify-content: center;
    background-color: rgba(0, 0, 0, .5);
  }

  #loading .van-loading__text {
    margin-top: 50px;
    color: #fff;
  }

  #loading .pay-know {
  	background: transparent;
  	color: #fff;
  	border-radius: 5px;
  	padding: 0 25px;
  	margin-top: 25px;
  }

</style>
